/**
 * P3-32: Pact 按钮（PactsBtnController / BuildingStackableBtn）。
 */
import { usePactButtonModel } from "./useReligionModel";
import { StackableButton } from "../../components/StackableButton";

interface PactButtonProps {
  pactName: string;
}

export function PactButton({ pactName }: PactButtonProps) {
  const { snap, modelRef, controller, getTooltip } = usePactButtonModel(pactName);

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <StackableButton
      snap={snap}
      controller={controller}
      getModel={() => modelRef.current}
      getTooltip={getTooltip}
    />
  );
}
